import { Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root',
})
export class DateHelperService {
    constructor() {}

    dateISOStringtoDate(dateString: string): Date {
        // "2022-11-19T00:00:00+01:00"
        const date = dateString.split('T')[0];
        const dateValues = date.split('-');
        if (!date || !dateValues || dateValues.length < 3) {
            throw new Error('No ISO Format found');
        }
        return new Date(Number(dateValues[0]), Number(dateValues[1]) - 1, Number(dateValues[2]));
    }

    dateToNgbDateStruct(date: Date): NgbDateStruct {
        return {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
        };
    }

    /**
     * Formats the booking day held in CalendarService.selectedDate as dd.MM.yyyy.
     *
     * That date was shifted by -getTimezoneOffset() (CalendarDateFirstService.onDateSelect)
     * so that toISOString() serializes the locally picked calendar day — the picked day
     * therefore lives in the UTC fields. Local getters would render the previous day in
     * UTC-negative timezones.
     */
    formatBookingDay(date: Date): string {
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();

        return `${day}.${month}.${year}`;
    }
}
